import styles from './RedCardBadge.module.scss';

const RedCardBadge = ({ redCards }) => {
    return redCards != null && redCards > 0 ? (
        <span className={styles.redCard}>{redCards === 1 ? null : redCards}</span>
    ) : null;
};

export default RedCardBadge;
